<nav class="navbar navbar-expand navbar-light bg-light border-bottom fixed-top">
  <a class="navbar-brand" [routerLink]="['/']">
    <img
      src="../assets/logo.png"
      width="30"
      height="30"
      class="d-inline-block align-top"
      alt=""
    />
    CampusNexus Administration Portal
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto"></ul>
    <ul class="navbar-nav">
      <li *ngIf="!isSignedIn()" class="nav-item">
        <a [routerLink]="['/home']" class="nav-link" (click)="login()"
          ><fa-icon icon="sign-in-alt"></fa-icon> Sign In</a
        >
      </li>
      <li *ngIf="isSignedIn()" class="nav-item">
        <a [routerLink]="['/home']" class="nav-link"
          ><fa-icon icon="user"></fa-icon> {{ profile?.displayName }}</a
        >
      </li>
      <li *ngIf="isSignedIn()" class="nav-item">
        <a [routerLink]="['/home']" class="nav-link" (click)="logout()"
          ><fa-icon icon="sign-out-alt"></fa-icon> Sign Out</a
        >
      </li>
    </ul>
  </div>
</nav>

<div class="sidebar">
  <div class="list-group list-group-flush">
    <li class="list-group-item"><b>Configuration</b></li>
    <a
      [routerLink]="['/configuration/tenants']"
      [routerLinkActive]="['active']"
      class="list-group-item list-group-item-action"
      ><fa-icon icon="users"></fa-icon> Tenants</a
    >
    <a
      [routerLink]="['/configuration/environments']"
      [routerLinkActive]="['active']"
      class="list-group-item list-group-item-action"
      ><fa-icon icon="users-cog"></fa-icon> Environments</a
    >
    <a
      [routerLink]="['/configuration/services']"
      [routerLinkActive]="['active']"
      class="list-group-item list-group-item-action"
      ><fa-icon icon="cogs"></fa-icon> Services</a
    >
    <li class="list-group-item">
      <b>Service Bus</b>
    </li>

    <a
      [routerLink]="['/service-bus']"
      [routerLinkActive]="['active']"
      class="list-group-item list-group-item-action"
      ><fa-icon icon="envelope"></fa-icon> Service Bus</a
    >
  </div>
</div>

<div class="outlet">
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
